"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EBackgroundMusicSong;

(function (EBackgroundMusicSong) {
  EBackgroundMusicSong["BATTLEGROUND"] = "battleground.mp3";
  EBackgroundMusicSong["DARK_KNIGHT"] = "darkknight.mp3";
  EBackgroundMusicSong["DESERT"] = "desert.mp3";
  EBackgroundMusicSong["FOREST_EVIL"] = "forestevil.mp3";
  EBackgroundMusicSong["GRASSLAND_01"] = "grassland01.mp3";
  EBackgroundMusicSong["GRASSLAND_02"] = "grassland02.mp3";
  EBackgroundMusicSong["LOBBY"] = "lobby.mp3";
  EBackgroundMusicSong["MOVE_FAST"] = "movefast.mp3";
  EBackgroundMusicSong["PARADISE_IN_THE_CITY"] = "paradiseinthecity.mp3";
  EBackgroundMusicSong["SWAMP"] = "swamp.mp3";
  EBackgroundMusicSong["THE_CASTLE"] = "thecastle.mp3";
  EBackgroundMusicSong["THE_TEMPLE"] = "thetemple.mp3";
  EBackgroundMusicSong["WHITE_FOREST"] = "whiteforest.mp3";
})(EBackgroundMusicSong || (EBackgroundMusicSong = {}));

var _default = EBackgroundMusicSong;
exports.default = _default;